import React from 'react';
import Icon from '@/v1/components/atoms/Icon';

import './Explore.scss';

const Explore = (props) => (
    <Icon iconName="Explore" {...props}>
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path
                strokeWidth={0}
                // eslint-disable-next-line
                d="M12.15 10.58A16.11 16.11 0 0012.37 8a16.31 16.31 0 00-.22-2.58c1.7.63 2.73 1.58 2.73 2.58s-1 1.95-2.73 2.58M8 14.88c-.94 0-1.95-1-2.58-2.73a16.11 16.11 0 002.58.22 16.11 16.11 0 002.58-.22C10 13.85 8.94 14.88 8 14.88M1.12 8c0-.94 1-1.95 2.73-2.58A16.11 16.11 0 003.63 8a16.31 16.31 0 00.22 2.58C2.15 10 1.12 8.94 1.12 8m10.13 0a13.26 13.26 0 01-.31 2.94 13.26 13.26 0 01-2.94.31 13.26 13.26 0 01-2.94-.31A13.26 13.26 0 014.75 8a13.26 13.26 0 01.31-2.94A13.26 13.26 0 018 4.75a13.26 13.26 0 012.94.31A13.26 13.26 0 0111.25 8M8 1.12c.94 0 1.95 1 2.58 2.73A16.11 16.11 0 008 3.63a16.11 16.11 0 00-2.58.22C6.05 2.15 7.06 1.12 8 1.12m3.85 3C11.11 1.66 9.68 0 8 0S4.89 1.66 4.15 4.15C1.66 4.89 0 6.32 0 8s1.66 3.11 4.15 3.85C4.89 14.34 6.32 16 8 16s3.11-1.66 3.85-4.15C14.34 11.11 16 9.68 16 8s-1.66-3.11-4.15-3.85"
            />
        </svg>
    </Icon>
);

export default Explore;
